<template>
  <app-base-main :no-padding="!padding" parentTable class="auto-table" >
    <template #filter-group>
      <WG-filter 
        :asinType="asinType"
        :filter="params"
        :query-loading="queryBtnLoading"
        @finish="finish"
        @reset="reset"
        @set-pagination="setPagination"
        @search="search">
      </WG-filter>

    </template>

      <template #operate-group>
<!--      <gj-tooltip :content="'此功能正在修复，暂时无法使用，即将开启'">-->
        <gj-button type="primary"
                   @click="importReport"
                   v-if="$permission('listingAnalyze:import')">
          导入业务报告
        </gj-button>
<!--      </gj-tooltip>-->

      <gj-checkbox v-model="showTestOrder">
        <span style="color: #666">推广订单</span>
      </gj-checkbox>
      <gj-checkbox v-model="promotionOrder">
        <span style="color: #666">促销订单</span>
      </gj-checkbox>
    </template>
    <template #tool-group>
      <gj-tool-group setting
        table-type="vxe-virtual-tree"
        :table-name="tableName"
        :table-columns="columns"
        :sort-gjtable="$refs.gjTable"
        :download="$permission('listingAnalyze:export')"
        download-url="/operation/listingAnalyze/show/export"
        :download-params="globalParams"
        help>
        
      </gj-tool-group>
    </template>
    <template #table>
      <gj-tree-table :list="tableData"
        ref="gjTable"
        adaptParent
        show-group
        :loading="loading"
        :columns="columns"
        :params="params"
        :pagerConfig="pagination"
        :show-summary="isMeaningful(summaryObject)"
        :summary-object="summaryObject"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">

        <template v-slot:image="{row}">
          <gj-image :src="row.imageUrl"></gj-image>
        </template>
        <template v-slot:listingInfo="{row}">
          <template v-if="params.groupType === 'asin'">
            <div>
              <gj-text>
                <gj-link :href="row.asinUrl"
                         target="_blank">{{ row.asin | defaultShow }}
                </gj-link>
              </gj-text>
              <!-- 复制指令 -->
              <gj-icon v-if="row.asin"
                       v-copy="defaultShow(row.asin)"
                       class="el-icon-copy-document table-tree-icon"></gj-icon>
            </div>
            <div>{{ row.salePrice | defaultShow(row.currencySymbol) }}</div>
          </template>
          <template v-else-if="params.groupType === 'variationAsin'">
            <div>
              <gj-text>
                <template v-if="row.parent">
                  <gj-link :href="row.variationAsinUrl"
                           target="_blank">{{ row.variationAsin | defaultShow }}
                  </gj-link>
                  <gj-icon v-copy="defaultShow(row.variationAsin)"
                           class="el-icon-copy-document table-tree-icon"></gj-icon>
                </template>
                <template v-else>
                  <gj-link :href="row.asinUrl"
                           target="_blank">{{ row.asin | defaultShow }}
                  </gj-link>
                  <gj-icon v-copy="defaultShow(row.asin)"
                           class="el-icon-copy-document table-tree-icon"></gj-icon>
                </template>
              </gj-text>
            </div>
            <div>{{ row.salePrice | defaultShow(row.currencySymbol) }}</div>
          </template>
          <template v-else-if="params.groupType === 'msku'">
            <el-row type="flex">
              <gj-text max-width="90%">{{ row.msku | defaultShow }}</gj-text>
              <gj-icon v-copy="defaultShow(row.msku)"
                       class="el-icon-copy-document table-tree-icon"></gj-icon>
            </el-row>
          </template>
        </template>

        <template v-slot:asins="{row}">
          <gj-icon iconfont="iconshuju1"
                   class="analysis-icon"
                   @click.native="handleNavigateAsin(row)"></gj-icon>
        </template>
        <!-- <template v-slot:buyBoxPercentage="{row}">
          <span>{{ isMeaningful(row.buyBoxPercentage) ? `${row.buyBoxPercentage}%` : '-' }}</span>
        </template> -->
        <template v-slot:listingMarketName="{row}">
          <template v-if="params.groupType === 'asin' || params.groupType === 'variationAsin'">
            <template v-if="row.parent && row.items && row.items.length > 1">{{ row.country | defaultShow }}</template>
            <template v-else>{{ row.marketName | defaultShow }}</template>
          </template>
          <template v-else>
            {{ row.marketName | defaultShow }}
          </template>
        </template>

        <template v-slot:product="{row}">
          <gj-text width="100%">{{ row.skuName | defaultShow }}</gj-text>
          <el-row type="flex">
            <template v-if="row.sku">
              <gj-popover-panel v-if="row.marketSkuList && row.marketSkuList.length > 1"
                                placement="right"
                                :width="'250px'"
                                :data="row.marketSkuList">
                <gj-text max-width="90%">{{ row.sku | defaultShow }}</gj-text>
              </gj-popover-panel>
              <template v-else>{{ row.sku | defaultShow }}</template>
            </template>
            <template v-else>-</template>
          </el-row>
        </template>

        <template v-slot:msku="{row}">
          <template v-if="row.parent">
            <gj-popover-panel v-if="row.marketMskuList && row.marketMskuList.length > 1"
                              placement="right"
                              :width="'250px'"
                              :data="row.marketMskuList">
              <gj-text max-width="90%">{{ row.msku | defaultShow }}</gj-text>
            </gj-popover-panel>
            <template v-else>{{ row.msku | defaultShow }}</template>
          </template>
          <template v-else>{{ row.msku | defaultShow }}</template>
        </template>

        <template v-slot:variationAsin="{row}">
          <template v-if="row.variationAsin">
            <gj-link :href="row.variationAsinUrl"
                     target="_blank">{{ row.variationAsin | defaultShow }}
            </gj-link>
            <gj-icon v-copy="row.variationAsin"
                     class="el-icon-copy-document table-tree-icon"></gj-icon>
          </template>
          <template v-else>-</template>
        </template>

        <template v-slot:asin="{row}">
          <gj-link :href="row.asinUrl"
                   target="_blank">{{ row.asin | defaultShow }}
          </gj-link>
          <gj-copy-icon v-if="row.asin"
                        :content="row.asin"/>
        </template>

        <template v-slot:unitsOrdered="{row}">
          <DataClickView @dataClick="handleClickColumn(row, 'unitsOrdered')" :text="row.unitsOrdered | defaultShow"/>
          <div class="order-class" v-if="showTestOrder">{{row.bogusQuantity | defaultShow}}</div>
          <div class="order-class" v-if="promotionOrder">{{row.promotionQuantity | defaultShow}}</div>
        </template>

        <template v-slot:orders="{row}">
          <DataClickView @dataClick="handleClickColumn(row, 'orders')" :text="row.orders | defaultShow"/>
          <div class="order-class" v-if="showTestOrder">{{row.bogusOrders | defaultShow}}</div>
          <div class="order-class" v-if="promotionOrder">{{row.promotionOrders | defaultShow}}</div>
        </template>

        <template v-slot:orderProductSales="{row}">
          <DataClickView @dataClick="handleClickColumn(row, 'orderProductSales')" :text="row.orderProductSales | defaultShow(row.currencySymbol)"/>
          <div class="order-class" v-if="showTestOrder">推{{row.bogusSalesCost | defaultShow(row.currencySymbol)}}</div>
          <div class="order-class" v-if="promotionOrder">促{{row.promotionSalesCost | defaultShow(row.currencySymbol)}}</div>
        </template>

        <template v-slot:fulfillableQuantity="{ row }">
          <gj-popover-panel title="FBA可售"
                            :width="'180px'"
                            :data="buildFBA(row)">
            {{ row.fulfillableQuantity | defaultShow }}
          </gj-popover-panel>
        </template>

        <template v-slot:saleableTurnover="{ row }">
          {{ row.saleableTurnover | defaultShow }}
        </template>

        <template v-slot:fulfillableQuantityFBM="{ row }">
          <gj-popover-panel title="FBM可售"
                            :width="'180px'"
                            :data="buildFBM(row)">
            {{ row.fulfillableQuantityFBM | defaultShow }}
          </gj-popover-panel>
        </template>

        <template v-slot:saleableTurnoverFBM="{ row }">
          {{ row.saleableTurnoverFBM | defaultShow }}
        </template>

        <template v-slot:header:fulfillableQuantityFBM>
          FBM可售
          <gj-help>
            <div>数据来源：取本地自营仓的可用量</div>
            <div>计算公式：可用量=良品量-预占量</div>
          </gj-help>
        </template>

        <template v-slot:group:Sessions>
          Sessions
          <gj-help>
            <template v-if="params.groupType==='asin'">
              <div>数据来源：插件—亚马逊业务报告（按商品ASIN）</div>
              <div>字段：sessions</div>
              <div>使用说明：单天查询直接取当天数据，多天查询取数据之和</div>
            </template>
            <template v-if="params.groupType==='variationAsin'">
              <div>数据来源：插件—亚马逊业务报告（按商品父ASIN）</div>
              <div>字段：sessions</div>
              <div>计算公式：副列表=ASIN数据</div>
              <div style="padding-left: 60px;">主列表=父ASIN数据</div>
              <div>使用说明：父ASIN报表页面有子ASIN数据，子ASIN数据来源于ASIN报表，两者数据在此页面不可合计对数据，且合计项子ASIN不参与计算</div>
            </template>
            <template v-if="params.groupType==='msku'">
              <div>数据来源：插件—亚马逊业务报告（按商品MSKU）</div>
              <div>字段：sessions</div>
              <div>使用说明：单天查询直接取当天数据，多天查询取数据之和</div>
            </template>
          </gj-help>
        </template>
        <template v-slot:group:PV>
          PV
          <gj-help>
            <template v-if="params.groupType==='asin'">
              <div>数据来源：插件—亚马逊业务报告（按商品ASIN）</div>
              <div>字段：PV</div>
              <div>使用说明：单天查询直接取当天数据，多天查询取数据之和</div>
            </template>
            <template v-if="params.groupType==='variationAsin'">
              <div>数据来源：插件—亚马逊业务报告（按商品父ASIN）</div>
              <div>字段：PV</div>
              <div>计算公式：副列表=ASIN数据</div>
              <div style="padding-left: 60px;">主列表=父ASIN数据</div>
              <div>使用说明：父ASIN报表页面有子ASIN数据，子ASIN数据来源于ASIN报表，两者数据在此页面不可合计对数据，且合计项子ASIN不参与计算</div>
            </template>
            <template v-if="params.groupType==='msku'">
              <div>数据来源：插件—亚马逊业务报告（按商品MSKU）</div>
              <div>字段：PV</div>
              <div>使用说明：单天查询直接取当天数据，多天查询取数据之和</div>
            </template>
          </gj-help>
        </template>
        <template v-slot:header:BuyBox>
          buybox
          <gj-help>
            <template v-if="params.groupType==='asin'">
              <div>数据来源：插件—亚马逊业务报告（按商品ASIN）</div>
              <div>字段：buybox</div>
              <div style="width: 320px;">计算公式：一天：副列表=buybox，主列表=副列表之和</div>
              <div style="padding-left: 60px;">多天：副列表/主列表=buybox之和/天数</div>
              <div>使用说明：①当天数据取报表数据，多天时取每天数据相加/天数，为0的天数也计入；② 当ASIN有父子关系时，当天主列表=副列表之和；多天时主列表=副列表之和/天数，为0或-天数也计入</div>
            </template>
            <template v-if="params.groupType==='variationAsin'">
              <div>数据来源：插件—亚马逊业务报告（按商品父ASIN）</div>
              <div>字段：buybox</div>
              <div>计算公式：副列表=ASIN数据</div>
              <div style="padding-left: 60px;">主列表=父ASIN数据/天数</div>
              <div>使用说明：父ASIN报表页面有子ASIN数据，子ASIN数据来源于ASIN报表，两者数据在此页面不可合计对数据，且合计项子ASIN不参与计算</div>
            </template>
            <template v-if="params.groupType==='msku'">
              <div>数据来源：插件—亚马逊业务报告（按商品MSKU）</div>
              <div>字段：buybox</div>
              <div style="width: 320px;">计算公式：一天：副列表=buybox，主列表=副列表之和</div>
              <div style="padding-left: 60px;">多天：副列表/主列表=buybox之和/天数</div>
              <div>使用说明：①当天数据取报表数据，多天时取每天数据相加/天数，为0的天数也计入；② 当ASIN有父子关系时，当天主列表=副列表之和；多天时主列表=副列表之和/天数，为0或-天数也计入</div>
            </template>
          </gj-help>
        </template>
        <template v-slot:header:CVR>
          CVR
          <gj-help>
            <template v-if="params.groupType==='asin'">
              <div>字段释义：订单转化率</div>
              <div>数据来源：自计算</div>
              <div>计算公式：总销量/sessions</div>
              <div>使用说明：单天查询直接取当天数据相除，多天查询取数据之和相除</div>
            </template>
            <template v-if="params.groupType==='variationAsin'">
              <div>字段释义：订单转化率</div>
              <div>数据来源：自计算</div>
              <div>计算公式：副列表=ASIN数据</div>
              <div style="padding-left: 60px;"> 主列表=父ASIN数据</div>
              <div>使用说明：父ASIN报表页面有子ASIN数据，子ASIN数据来源于ASIN报表，两者数据在此页面不可合计对数据，且合计项子ASIN不参与计算</div>
            </template>
            <template v-if="params.groupType==='msku'">
              <div>字段释义：订单转化率</div>
              <div>数据来源：自计算</div>
              <div>计算公式：总销量/sessions</div>
              <div>使用说明：单天查询直接取当天数据相除，多天查询取数据之和相除</div>
            </template>
          </gj-help>
        </template>

<!--        Sessions-->
        <template v-slot:sessions="{ row }">
          <div class="flex align-center justify-center">

            <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'sessions')">
                {{ row.sessions | defaultShow }}
              </span>
            </gj-tooltip>
            <DataClickView v-else @dataClick="handleClickColumn(row, 'sessions')" :text="row.sessions| defaultShow"/>
          </div>
        </template>
         <template v-slot:sessionsMobile="{ row }">
          <div class="flex align-center justify-center">
            <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'sessionsMobile')">
                {{ row.sessionsMobile | defaultShow }}
              </span>
            </gj-tooltip>
            <DataClickView v-else @dataClick="handleClickColumn(row, 'sessionsMobile')" :text="row.sessionsMobile | defaultShow"/>
          </div>
        </template>
         <template v-slot:sessionsBrowser="{ row }">
          <div class="flex align-center justify-center">

            <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'sessionsBrowser')">
                {{ row.sessionsBrowser | defaultShow }}
              </span>
            </gj-tooltip>
            <DataClickView v-else @dataClick="handleClickColumn(row, 'sessionsBrowser')" :text="row.sessionsBrowser | defaultShow"/>
          </div>
        </template>
<!--        CVR-->
        <template v-slot:unitSessionPercentage="{ row }">
          <div class="flex align-center justify-end">

            <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'unitSessionPercentage')">
               {{ row.unitSessionPercentage | defaultShow('','%') }}
              </span>
            </gj-tooltip>
            <DataClickView v-else @dataClick="handleClickColumn(row, 'unitSessionPercentage')" :text="row.unitSessionPercentage | defaultShow('','%')"/>
          </div>

        </template>
<!--        PV，START-->
        <template v-slot:pageViews="{ row }">
          <div class="flex align-center justify-center">
            <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'pageViews')">
                {{ row.pageViews | defaultShow }}
              </span>
            </gj-tooltip>
            <DataClickView v-else @dataClick="handleClickColumn(row, 'pageViews')" :text="row.pageViews | defaultShow"/>
          </div>
        </template>
        <template v-slot:pageViewsBrowser="{ row }">
          <div class="flex align-center justify-center">
            <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError"  @click="handleClickColumn(row, 'pageViewsBrowser')">
                {{ row.pageViewsBrowser | defaultShow }}
              </span>
            </gj-tooltip>
            <DataClickView v-else @dataClick="handleClickColumn(row, 'pageViewsBrowser')" :text="row.pageViewsBrowser | defaultShow"/>
          </div>
        </template>
        <template v-slot:pageViewsMobile="{ row }">
          <div class="flex align-center justify-center">
            <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'pageViewsMobile')">
                {{ row.pageViewsMobile | defaultShow }}
              </span>
            </gj-tooltip>
            <DataClickView v-else @dataClick="handleClickColumn(row, 'pageViewsMobile')" :text="row.pageViewsMobile | defaultShow"/>
          </div>
        </template>
<!--        PV， END-->

<!--        BuyBox-->
        <template v-slot:buyBoxPercentage="{ row }">
          <div class="flex align-center justify-end">

            <gj-tooltip :content="'数据缺失，异常'" v-if="row.trafficError">
              <span class="trafficError" @click="handleClickColumn(row, 'buyBoxPercentage')">
                 {{ row.buyBoxPercentage | defaultShow('','%') }}
              </span>
            </gj-tooltip>
            <DataClickView v-else @dataClick="handleClickColumn(row, 'buyBoxPercentage')" :text="row.buyBoxPercentage | defaultShow('','%')"/>
          </div>
        </template>

        <template v-slot:crawlTitle="{ row }">
          <gj-tooltip :content="row.crawlTitle" :textLine="2">{{row.crawlTitle | defaultShow}}</gj-tooltip>
        </template>
        <template v-slot:categoryName="{ row }">
          <gj-tooltip :content="row.categoryName" :textLine="2">{{row.categoryName | defaultShow}}</gj-tooltip>
        </template>
        <template v-slot:brandName="{ row }">
          <gj-tooltip :content="row.brandName" :textLine="2">{{row.brandName | defaultShow}}</gj-tooltip>
        </template>
        <template v-slot:sellingManagerNames="{ row }">
          <gj-tooltip :content="row.sellingManagerNames" :textLine="2">{{row.sellingManagerNames | defaultShow}}</gj-tooltip>
        </template>



        <!-- 模板写法 -->
        <template v-for="item in loop_fields"  v-slot:[item.field]="{row}">
          <div :key="item.field">
            <DataClickView @dataClick="handleClickColumn(row, item.field)" :text="(row[item.field]) | defaultShow(row[item.prefix], item.suffix)"/>
          </div>
        </template>

      </gj-tree-table>
    </template>
  </app-base-main>

</template>

<script>
import WGFilter from './widget/filter.vue'
import {queryMixin, noRepeatQueryMixin} from "@/minxins";
import {analysisMixin} from "./mixins/index";
import importModal from './widget/import-modal.vue'
import {isMeaningless, isMeaningful, toFixed} from "@/utils/common";
import {getListingPerformedAnalysis, trafficTrendInfo} from "@/api/statistics";
import {columns1, loop_fields} from './data'
import {convertToFullDate} from "@/utils/date.util";
import _ from 'lodash'
import {defaultShow} from '@/filters'
import DataClickView from '@/views/modules/statistics/common/analysis/goods-analysis/widget/data-click-view';
import OperationAnalysisModalNew from "modules/sale/listing/modal/operation-analysis-modal-new";


export default {
  components: {WGFilter, DataClickView},
  mixins: [queryMixin, noRepeatQueryMixin, analysisMixin],
  name: 'listingAnalysisNew',
  props: {
    asinType: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      // showType: '',
      loop_fields,
      isMeaningful,
      tableName:'listingAnalysisPerformanceV2',
      tableData:[],
      /**
       * columns 表格列表配置 前缀后缀使用formatter 进行处理
       * @type { Object[]}
       * @desc 数组
       * columns[].default 设置自定义列的时候 是不是默认选中
       * columns[].disabled 设置自定义列的时候 能否进行勾选操作
       * columns[].visible 设置是否表格展示 类似v-show功能
       * columns[].summary 设置是否进行合计
       */
      columns: [],
      params: {
        // groupType: 'asin',
        groupType: '',
        currency: '',
        categoryIds: null,
        brandId: null,
        countryAndMarket: null,
        keyword: {
          key: '',
          value: null,
        },
        date: null,
        userPermission: null,
        chargeIdList: null,
      },
      showTestOrder: false,
      promotionOrder: false,
      // queryMixin 缓存获取key值
      filterKey: 'params',
      summaryObject: null,
      cacheOptions: {
        filterKey: 'params'
      },
      isNeedCache: false,

      type:null,
      chartData:[],
      chartLoading:true,
      sessionsGroupType: [
        { field: 'sessionsMobile', label: 'sessions-移动端' },
        { field: 'sessionsBrowser', label: 'sessions-PC端' },
        { field: 'sessions', label: 'sessions-总计' }
      ],
      pvGroupType: [
        { field: 'pageViewsMobile', label: 'PV-移动端' },
        { field: 'pageViewsBrowser', label: 'PV-PC端' },
        { field: 'pv', label: 'PV-总计' }
      ]
    }
  },
  computed: {
    CACHE_PARAMS() {
      return {
        ...this.params
      }
    }
  },
  watch: {
    asinType(val){
      this.params.groupType = this.asinType;
      this.handleColumn(this.asinType)
    }
  },
  created() {
    this.params.groupType = this.asinType;
    this.cacheOptions.filterKey = this.asinType;
    this.filterKey =  this.asinType;
    this.sort.prop = 'unitsOrdered';
    this.handleColumn(this.params.groupType)
    let cacheData = this.getCacheData()
    if (cacheData && cacheData.pagination) {
      this.pagination.pageSize = cacheData.pagination.pageSize
    }

  },
  methods: {

    handRankingChart(row,type){
      if(row.chartData){
        this.type = type;
        this.chartData = row.chartData;
        this.chartLoading = false;
        return
      }
      let param = {
        startStatisticsDate:this.params.startStatisticsDate,
        endStatisticsDate:this.params.endStatisticsDate,
        groupType:this.params.groupType
      };
      if(this.params.groupType === 'asin'){
        param.asin = row.asin
        if(!row.items){
          //没有子级数据，传marketId
          param.marketId = row.marketId;
        }
      }else if(this.params.groupType === 'variationAsin'){
        if(!row.parent){
          param.marketId = row.marketId;
          param.asin = row.asin;
          param.groupType = 'asin';
        }else {
          param.variationAsin = row.variationAsin
        }
      }else if(this.params.groupType === 'msku'){
        param.msku = row.msku;
        param.marketId = row.marketId;
      }
      trafficTrendInfo(param).then(res =>{
        row.chartData = res;
        this.type = type;
        this.chartData = res;
        this.chartLoading = false;
      })
    },
    defaultShow,
    customCacheCallback() {
      this.setCacheData()
    },
    $gjCacheCallback(params) {
      return {
        groupType: params.groupType,
        countryAndMarket: params.countryAndMarket
      };
    },
    finish(params) {
      this.params = params;
      this.$gjQuery()
    },
    reset(params) {
      this.pagination.currentPage = 1;
      this.params = params
      this.$gjReset()
    },
    setPagination(pages) {
      this.pagination.pageSize = pages.pageSize || 20
    },
    handleTitle(val) {
      
      columns1.map(v => {
        v.checked = true
        return v
      })
      const asinDimension = val === 'asin';
      const variationAsinDimension = val === 'variationAsin';
      const mskuDimension = val === 'msku';
      const index = columns1.findIndex(v => v.field === 'listingInfo')

      const indexSessions = columns1.findIndex(v=>v.field === 'sessions')
      const indexPV = columns1.findIndex(v=>v.field === 'pageViews')
      const indexbuybox = columns1.findIndex(v=>v.field === 'buyBoxPercentage')
      const indexCVR = columns1.findIndex(v=>v.field === 'unitSessionPercentage')


      if (val === 'variationAsin') {
        columns1[index].title = '父ASIN/售价'
        columns1[index].sortBy = 'variationAsin'
        if (this.sort.prop === 'msku') {
          this.sort.prop = 'unitsOrdered';
        }
        // this.setHelpStr(indexSessions,indexPV,indexbuybox,indexCVR,'按商品父ASIN')
      }else if(val === 'asin'){
        columns1[index].title = 'ASIN/售价'
        columns1[index].sortBy = 'asin'
        if (this.sort.prop === 'msku') {
          this.sort.prop = 'unitsOrdered';
        }
        // this.setHelpStr(indexSessions,indexPV,indexbuybox,indexCVR,'按商品ASIN')
      } else {
        columns1[index].title = 'MSKU';
        columns1[index].sortBy = 'msku';
        if (this.sort.prop === 'variationAsin' || this.sort.prop === 'sku') {
          this.sort.prop = 'unitsOrdered';
        }
        // this.setHelpStr(indexSessions,indexPV,indexbuybox,indexCVR,'按商品MSKU')
      }
      // const index2 =columns1.findIndex(v=>v.field ==='imageUrl')
      // columns1[index2].id = `picture${val}`;
      // ASIN分析
      let index3 = columns1.findIndex(m => m.field === 'asins')
      columns1[index3].exist = asinDimension || variationAsinDimension;
      // ASIN
      let index4 = columns1.findIndex(m => m.field === 'asin')
      columns1[index4].exist = variationAsinDimension || mskuDimension;
      // 父ASIN
      let index5 = columns1.findIndex(m => m.field === 'variationAsin')
      columns1[index5].exist = asinDimension || mskuDimension;
      columns1[index5].sortable = asinDimension || variationAsinDimension;
      //  产品/sku
      let index6 = columns1.findIndex(m => m.field === 'product');
      columns1[index6].sortable = asinDimension || variationAsinDimension;
    },
    // setHelpStr(indexSessions,indexPV,indexbuybox,indexCVR,str){
    //   columns1[indexSessions].titleHelp.message =
    //       `数据来源：插件—亚马逊业务报告（${str}）
    //         字段：sessions`;
    //   columns1[indexPV].titleHelp.message =
    //       `数据来源：插件—亚马逊业务报告（${str}）
    //         字段：PV`;
    //   columns1[indexbuybox].titleHelp.message =
    //       `数据来源：插件—亚马逊业务报告（${str}）
    //         字段：buybox`;
    //   columns1[indexCVR].titleHelp.message =
    //       `字段释义：订单转化率
    //       数据来源：自计算
    //         字段：销量/sessions`;
    // },
    // 切换tab columns数据变化
    handleColumn(val) {
      this.handleTitle(val)
      let columns = _.cloneDeep(columns1)
      this.columns = columns
    },
    $gjQuery() {
      if (isMeaningless(this.params) || isMeaningless(this.params.startStatisticsDate) || isMeaningless(this.params.endStatisticsDate)) return;
      this.loading = true;
      this.queryBtnLoading = true;
      let params = {
        model: {
          ...this.params,
          showTest: this.showTestOrder,
          showPromotion: this.promotionOrder,
        },
        ...this.queryPagination,
        ...this.querySort
      }
      this.globalParams = params;
      getListingPerformedAnalysis(params).then(data => {
        this.tableData = data.records.map((item, index) => {
          item.parent = true;
          if (item.expandItems && item.expandItems.length > 1) {
            item.marketMskuList = [{label: '产品名称', value: 'SKU', bold: true}, ...(item.expandItems || []).map(v => ({
              label: v.col1,
              value: v.col2
            }))]
          }
          if (item.items && item.items.length > 0) {
            item.items.map(childItem => {
              childItem.marketSkuList = [{
                label: '产品名称',
                value: 'SKU',
                bold: true
              }, ...(childItem.expandItems || []).map(v => ({
                label: v.col1,
                value: v.col2
              }))]
            })
          }
          item.index = index + 1
          return item
        })
        this.pagination = this.getPagination(data);
        this.summaryObject = data.statisticRecord;
      }).complete(() => {
        this.loading = false;
        this.queryBtnLoading = false;
      })
    },
    search(params) {
      this.params = params;
      this.$gjNoticeQuery();
    },
    importReport() {
      this.$gjCreate(importModal, {
        props:{
          groupType:this.params.groupType
        },
        on: {
          authed: () => {
            this.$gjResetPage();
          }
        }
      });
    },
    /**
     * popover详情
     * @param row
     */
    buildFBA(row) {
      return [
        [
          {label: 'FBA可售', value: row.fulfillableQuantity}
        ],
        [
          {label: '转运中', value: row.reservedTransfers},
          {label: '处理中', value: row.reservedProcessing},
          {label: '小计', value: row.reservedSum, bold: true},
        ],
        [
          {label: '计划入库', value: row.planInboundQuantityFBA},
          {label: '已发货', value: row.alreadyShipQuantity},
          {label: '入库中', value: row.inboundingQuantity},
          {label: '小计', value: row.quantityFBA, bold: true}
        ]
      ]
    },
    /**
     * popover详情
     */
    buildFBM(row) {
      return [
        [
          {label: 'FBM可售', value: row.fulfillableQuantityFBM}
        ],
        [
          {label: '采购量', value: row.purchaseQuantity},
          {label: '已下单', value: row.alreadyOrderQuantity},
          {label: '交货量', value: row.deliveryQuantity},
          {label: '计划入库', value: row.planInboundQuantityFBM},
          {label: '小计', value: row.quantityFBM, bold: true}
        ]
      ]
    },
    /**
     * 跳转asin看板
     * @param row
     */
    handleNavigateAsin(row) {
      // console.log(this.params)
      const queryParams = {
        asinType: this.params.groupType === 'variationAsin' ? 'parent' : 'child',
        asinCode: this.params.groupType === 'variationAsin' ? row.variationAsin : row.asin,
        countryData: {
          countryIds: [row.country], // 国家
          marketIds: [row.marketId], // 店铺
        },
        date: {
          type: 'DAY',
          value: [
            convertToFullDate(this.params.date[0], 'yyyy-MM-dd'),
            convertToFullDate(this.params.date[1], 'yyyy-MM-dd'),
          ]
        }
      };
      if (this.params.groupType === 'variationAsin') {
        // params.asinType = row.parent ? 'parent' : 'child'
        // params.asinCode = row.parent ? row.variationAsin : row.asin
        if (row.parent && row.variationAsin) {
          queryParams.asinType = 'parent'
          queryParams.asinCode = row.variationAsin
        } else {
          queryParams.asinType = 'child'
          queryParams.asinCode = row.asin
        }
      }
      this.$router.push({path: '/statistics/asin-361-analysis', query: {params: JSON.stringify(queryParams)}})
    },

    /**
     * 显示弹窗
     */
    handleClickColumn(row, field){
      let params =  this.params;
      let groupType = this.asinType;
      console.log('当前参数是',params)
      // this.$message(field)
      this.$gjCreate(OperationAnalysisModalNew,{
        props: {
          params:{
            ...params,
            groupType:groupType,
            row:row,
            field:field
          }
          
        }
      })
    },
    getFixData(value){
      console.log('star=', toFixed(value))
      return toFixed(value)
    },
  }
}
</script>


<style scoped lang="scss">
  .auto-table{
    height: 100% ; 
    box-sizing: border-box;
  }
  .auto-table /deep/ .table{
    flex: 1;
    overflow: auto;
    height: 100% ; 
  }
  .order-class {
    color: #999;
    padding-top: 1px;
  }
  /deep/ .vxe-cell--title{
    .gj-icon{
      color: #333!important;
      font-size: 14px!important;
    }
  }
</style>

<style lang="scss">
.vxe-grid-height {
  height: 100%;

  .table {
    height: calc(100% - 90px) ;

  }

  .vxe-table--render-default:not(.is--empty).is--footer.is--scroll-x .vxe-table--body-wrapper {
    overflow-x: hidden;
  }
}
.trafficError{
  color:#F5222D;
}
.gj-tooltip--default{
  max-width: 300px;
}





</style>
